class TawkService {
  constructor() {
    this.propertyId = null // Artık API'den alınacak
    this.widgetId = null // Artık API'den alınacak
    this.isInitialized = false
    this.routeConfigs = this.initializeRouteConfigs()
    this.autoResponses = this.initializeAutoResponses()
    this.greetingMessages = this.initializeGreetingMessages()
    this.hasShownGreeting = new Set()
  }

  // Session ID'yi al
  getSessionId() {
    try {
      // Önce mevcut user objesinden dene
      if (window.Vue && window.Vue.prototype.$getUser) {
        const user = window.Vue.prototype.$getUser()
        if (user && user.session_id) {
          return user.session_id
        }
      }

      // SessionStorage'dan dene
      const sid = sessionStorage.getItem('sid')
      if (sid) {
        return sid
      }

      // localStorage'dan kullanıcı bilgisini al
      const userKey = Object.keys(localStorage).find(key => key.startsWith('user_'))
      if (userKey) {
        const userData = JSON.parse(localStorage.getItem(userKey))
        if (userData && userData.session_id) {
          return userData.session_id
        }
      }

      return null
    } catch (error) {
      console.error('Session ID alma hatası:', error)
      return null
    }
  }

  
  // Şifrelenmiş değeri çöz
  decryptValue(encryptedValue) {
    try {
      // İlk olarak global unlock fonksiyonunu dene
      if (window.$unlock && typeof window.$unlock === 'function') {
        return window.$unlock(encryptedValue)
      }

      // Vue 2 için prototype kontrolü
      if (window.Vue && window.Vue.prototype && window.Vue.prototype.$unlock) {
        return window.Vue.prototype.$unlock(encryptedValue)
      }

      // Vue 3 için app instance kontrolü
      if (window.app && window.app.config && window.app.config.globalProperties && window.app.config.globalProperties.$unlock) {
        return window.app.config.globalProperties.$unlock(encryptedValue)
      }

      // Son çare: Manual decrypt attempt
      console.warn('🔒 Decrypt fonksiyonu bulunamadı. Encrypted değer:', encryptedValue)
      console.warn('💡 main.js\'de window.$unlock = app.config.globalProperties.$unlock ekleyin')
      
      // Geçici: Base64 decode dene
      try {
        const decoded = atob(encryptedValue)
        console.log('🧪 Base64 decode denendi:', decoded)
        return decoded
      } catch (base64Error) {
        console.warn('❌ Base64 decode başarısız, original değer döndürülüyor')
        return encryptedValue
      }
      
    } catch (error) {
      console.error('❌ Değer çözme hatası:', error)
      return encryptedValue
    }
  }

  // API'den Tawk bilgilerini al
  async getTawkDetailsFromAPI() {
    try {
      const sessionId = this.getSessionId()
      if (!sessionId) {
        throw new Error('Session ID bulunamadı')
      }

      const response = await window.axios.post('/api/Auth/GetTawkDetails', {
        session_id: sessionId
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      })

      if (response.data && response.data.tawk_property_id && response.data.tawk_widget_id) {
        // Şifrelenmiş değerleri çöz
        const decryptedPropertyId = this.decryptValue(response.data.tawk_property_id)
        const decryptedWidgetId = this.decryptValue(response.data.tawk_widget_id)
        
        // Property ve Widget ID'lerini ayarla
        this.propertyId = decryptedPropertyId
        this.widgetId = decryptedWidgetId
        
        console.log('Tawk bilgileri API\'den alındı')
        return true
      } else {
        throw new Error('API\'den geçerli Tawk bilgileri alınamadı')
      }
    } catch (error) {
      console.error('Tawk bilgileri alma hatası:', error)
      // Fallback değerler (isteğe bağlı)
      this.propertyId = '6880a581dcb35d1917a36eb9'
      this.widgetId = '1j0r8d0f9'
      return false
    }
  }

  // Route konfigürasyonları
  initializeRouteConfigs() {
    return {
      'Home': { department: 'general', greeting: 'Sistem hakkında yardıma ihtiyacınız var mı?' },
      'CustomerList': { department: 'sales', greeting: 'Müşteri yönetimi konusunda size yardımcı olabilirim.' },
      'CustomerCreate': { department: 'sales', greeting: 'Yeni müşteri ekleme konusunda yardıma ihtiyacınız var mı?' },
      'InvoiceList': { department: 'billing', greeting: 'Fatura işlemleri konusunda size nasıl yardımcı olabilirim?' },
      'InvoiceCreate': { department: 'billing', greeting: 'Yeni fatura oluşturma sürecinde yanınızdayım.' },
      'BankList': { department: 'technical', greeting: 'Banka hesap yönetimi konusunda yardımcı olabilirim.' },
      'StockList': { department: 'technical', greeting: 'Stok yönetimi konusunda size yardımcı olabilirim.' },
      'Settings': { department: 'technical', greeting: 'Sistem ayarları konusunda teknik destek sağlayabilirim.' },
      'BalanceSheet': { department: 'technical', greeting: 'Bilanço raporları konusunda yardımcı olabilirim.' },
      'AccountingVoucherList': { department: 'technical', greeting: 'Muhasebe fişleri konusunda teknik destek sağlayabilirim.' },
      'default': { department: 'general', greeting: 'Size nasıl yardımcı olabilirim?' }
    }
  }

  // Karşılama mesajları
  initializeGreetingMessages() {
    return {
      'InvoiceCreate': {
        message: '📝 Yeni fatura oluşturuyorsunuz! Fatura hazırlama sürecinde size yardımcı olabilirim.',
        delay: 2000
      },
      'CustomerCreate': {
        message: '👤 Yeni müşteri ekliyorsunuz. Müşteri bilgileri konusunda destek verebilirim.',
        delay: 2500
      },
      'StockCreate': {
        message: '📦 Yeni stok kalemi ekliyorsunuz. Stok kodları ve kategoriler konusunda yardımcı olabilirim.',
        delay: 2000
      },
      'Settings': {
        message: '⚙️ Sistem ayarlarındasınız. Hangi ayarı yapmakta zorlanıyorsunuz?',
        delay: 3000
      }
    }
  }

  // Otomatik cevap sistemi
  initializeAutoResponses() {
    return {
      'InvoiceCreate': [
        {
          keywords: ['nasıl', 'fatura', 'hazırla', 'oluştur'],
          response: `📝 **Fatura Hazırlama Adımları:**\n\n1. Müşteri seçin\n2. Ürün/hizmet ekleyin\n3. Fiyat ve miktar girin\n4. KDV oranlarını seçin\n5. Kaydedin`,
          priority: 1
        },
        {
          keywords: ['kdv', 'vergi', 'oran'],
          response: `💰 **KDV Oranları:**\n\n• %1: Temel gıda\n• %10: Kitap, ilaç\n• %20: Genel oran`,
          priority: 2
        }
      ],
      'CustomerCreate': [
        {
          keywords: ['vergi', 'numara', 'kontrol', 'tc'],
          response: `🔍 **Vergi/TC Kimlik Kontrolü:**\n\n• TC: 11 haneli olmalı\n• Vergi no: 10 haneli olmalı\n• Sistem otomatik kontrol yapar`,
          priority: 1
        }
      ],
      'StockCreate': [
        {
          keywords: ['stok', 'kod', 'otomatik'],
          response: `📦 **Stok Kodu:**\n\n• Sistem otomatik kod üretir\n• Manuel kod girebilirsiniz\n• Kod benzersiz olmalıdır`,
          priority: 1
        }
      ]
    }
  }

  // Tawk.to'yu başlat
  async initialize() {
    if (this.isInitialized) return Promise.resolve()

    // Önce API'den Tawk bilgilerini al
    await this.getTawkDetailsFromAPI()

    // Property ve Widget ID kontrol
    if (!this.propertyId || !this.widgetId) {
      throw new Error('Tawk Property ID veya Widget ID bulunamadı')
    }

    return new Promise((resolve, reject) => {
      try {
        if (window.Tawk_API && typeof window.Tawk_API.onLoad !== 'undefined') {
          this.isInitialized = true
          this.setupEventListeners()
          resolve()
          return
        }

        window.Tawk_API = window.Tawk_API || {}
        window.Tawk_LoadStart = new Date()

        const script = document.createElement('script')
        script.async = true
        script.src = `https://embed.tawk.to/${this.propertyId}/${this.widgetId}`
        script.charset = 'UTF-8'
        script.setAttribute('crossorigin', '*')

        script.onload = () => {
          this.waitForTawkAPI().then(() => {
            this.isInitialized = true
            this.setupEventListeners()
            resolve()
          }).catch(reject)
        }

        script.onerror = () => reject(new Error('Tawk.to script yüklenemedi'))

        const firstScript = document.getElementsByTagName('script')[0]
        firstScript.parentNode.insertBefore(script, firstScript)
      } catch (error) {
        reject(error)
      }
    })
  }

  // API hazır olmasını bekle
  waitForTawkAPI(maxAttempts = 30) {
    return new Promise((resolve, reject) => {
      let attempts = 0
      
      const checkAPI = () => {
        attempts++
        if (window.Tawk_API && typeof window.Tawk_API.setAttributes === 'function') {
          resolve()
        } else if (attempts >= maxAttempts) {
          reject(new Error('Tawk API hazır olmadı'))
        } else {
          setTimeout(checkAPI, 100)
        }
      }
      
      checkAPI()
    })
  }

  // Event listener'ları kur
  setupEventListeners() {
    if (!window.Tawk_API) return

    window.Tawk_API.onLoad = () => {
      console.log('Tawk.to hazır')
    }

    window.Tawk_API.onChatStarted = () => {
      this.sendPageContextMessage()
    }

    window.Tawk_API.onChatMessageVisitor = (message) => {
      setTimeout(() => this.checkForAutoResponse(message), 1000)
    }
  }

  // Route değiştiğinde çağır
  updateForRoute(routeName, routePath = '') {
    if (!this.isInitialized) return

    this.whenTawkReady(() => {
      this.updatePageInfo(routeName, routePath)
      this.showPageGreeting(routeName)
    })
  }

  // Sayfa bilgilerini güncelle
  updatePageInfo(routeName) {
    const config = this.getConfigForRoute(routeName)
    
    const attributes = {
      'Current URL': window.location.href,
      'Current Page': this.getReadablePageName(routeName),
      'Department': config.department,
      'Route Name': routeName,
      'Visit Time': new Date().toLocaleString('tr-TR')
    }

    window.Tawk_API.setAttributes(attributes)
    
    window.Tawk_API.addEvent('page_visit', {
      route: routeName,
      url: window.location.href,
      department: config.department,
      timestamp: new Date().toISOString()
    })
  }

  // Karşılama mesajı göster
  showPageGreeting(routeName) {
    const greeting = this.greetingMessages[routeName]
    if (!greeting || this.hasShownGreeting.has(routeName)) return

    setTimeout(() => {
      window.Tawk_API.addEvent('page_greeting', {
        message: greeting.message,
        page: this.getReadablePageName(routeName),
        timestamp: new Date().toISOString()
      })
      
      this.hasShownGreeting.add(routeName)
    }, greeting.delay)
  }

  // Sayfa context mesajı
  sendPageContextMessage() {
    const currentRoute = this.getCurrentRouteName()
    const readablePage = this.getReadablePageName(currentRoute)
    
    window.Tawk_API.addEvent('chat_context', {
      message: `📍 Kullanıcı "${readablePage}" sayfasından sohbet başlattı`,
      url: window.location.href,
      timestamp: new Date().toISOString()
    })
  }

  // Otomatik cevap kontrol
  checkForAutoResponse(message) {
    const currentRoute = this.getCurrentRouteName()
    const responses = this.autoResponses[currentRoute]
    
    if (!responses || !message) return

    const lowerMessage = message.toLowerCase()
    let bestMatch = null
    let maxScore = 0

    responses.forEach(response => {
      let score = 0
      response.keywords.forEach(keyword => {
        if (lowerMessage.includes(keyword.toLowerCase())) {
          score += response.priority
        }
      })

      if (score > maxScore) {
        maxScore = score
        bestMatch = response
      }
    })

    if (bestMatch && maxScore > 0) {
      setTimeout(() => {
        window.Tawk_API.addEvent('auto_response', {
          response: bestMatch.response,
          page: currentRoute,
          timestamp: new Date().toISOString()
        })
      }, 2000)
    }
  }

  // Kullanıcı bilgilerini ayarla
  setVisitorInfo(userData) {
    this.whenTawkReady(() => {
      if (!userData) return

      const attributes = {}
      
      if (userData.name_surname) {
        const nameParts = userData.name_surname.split(' ')
        attributes.userInitials = nameParts.map(part => part.charAt(0).toUpperCase()).join('.')
      }
      
      if (userData.company_name) attributes.companyName = userData.company_name
      if (userData.permission_type !== undefined) {
        attributes.userType = userData.permission_type === 1 ? 'admin' : 'user'
      }
      if (userData.licence_name) attributes.licenceType = userData.licence_name
      if (userData.user_mail) attributes.licenceType = userData.user_mail

      window.Tawk_API.setAttributes(attributes)
    })
  }

  // Yardımcı metodlar
  whenTawkReady(callback) {
    if (window.Tawk_API && typeof window.Tawk_API.setAttributes === 'function') {
      callback()
    } else {
      setTimeout(() => this.whenTawkReady(callback), 100)
    }
  }

  getCurrentRouteName() {
    if (window.$router && window.$router.currentRoute) {
      return window.$router.currentRoute.name
    }
    return 'Unknown'
  }

  getConfigForRoute(routeName) {
    return this.routeConfigs[routeName] || this.routeConfigs['default']
  }

  getReadablePageName(routeName) {
    const pageNames = {
      'Home': 'Ana Sayfa',
      'CustomerList': 'Müşteri Listesi',
      'CustomerCreate': 'Yeni Müşteri',
      'InvoiceList': 'Fatura Listesi',
      'InvoiceCreate': 'Yeni Fatura',
      'BankList': 'Banka Hesapları',
      'StockList': 'Stok Listesi',
      'StockCreate': 'Yeni Stok',
      'Settings': 'Sistem Ayarları',
      'BalanceSheet': 'Bilanço Raporu',
      'AccountingVoucherList': 'Muhasebe Fişleri'
    }
    
    return pageNames[routeName] || routeName || 'Bilinmeyen Sayfa'
  }

  // Widget kontrol
  hideWidget() {
    if (window.Tawk_API && typeof window.Tawk_API.hideWidget === 'function') {
      window.Tawk_API.hideWidget()
    }
  }

  showWidget() {
    if (window.Tawk_API && typeof window.Tawk_API.showWidget === 'function') {
      window.Tawk_API.showWidget()
    }
  }
}

export default new TawkService()